import { controls, grouped } from "../controls";
const generate_salarys = {
    label: "Generate Salarys",
    pageLabel: "Generate Salarys", starting: true, url: "autogen",
    formActions: { edit: { allow: true }, delete: { allow: false } },
    pageType: "history",
    filter: [
        ...controls.displayText({
            tab: "filter", label: "Employee",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "GenerateSalary-employee-employee_code", controlType: "Employee", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "filter", label: "Branch" }),
        ...controls.autoComplete({ tab: "filter", name: "GenerateSalary-branch-branch_code", width: "col-sm-2", controlType: "Branch" }),
        ...controls.displayText({ tab: "filter", label: "" }),
        ...controls.displayText({ tab: "filter", label: "Designation" }),
        ...controls.autoComplete({ tab: "filter", name: "GenerateSalary-designation-designation_code", width: "col-sm-2", controlType: "Designation" }),
        ...controls.displayText({ tab: "filter", label: "" }),
        ...controls.displayText({ tab: "filter", label: "Department" }),
        ...controls.autoComplete({ tab: "filter", name: "GenerateSalary-department-department_code", width: "col-sm-2", controlType: "Department" }),
        ...controls.displayText({ tab: "filter", label: "" }),
        ...controls.displayText({
            tab: "filter", label: "EmploymentStatus",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "GenerateSalary-employment_status-employment_status_code", controlType: "EmploymentStatus", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

        ...controls.displayText({
            tab: "filter", label: "EmploymentGrade",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "GenerateSalary-employment_grade-employment_grade_code", controlType: "EmploymentGrade", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),


        ...controls.magicDateLabel({ tab: "general", label: "Salary Month", target: "salary_month", star: true }),
        ...controls.magicDate({ tab: "general", name: "month", dateType: "monthYear", isRequired: true, isReadOnly: "edit", displayFormat: "MMMM yyyy" }),
        ...controls.displayText({ tab: "general", label: "" }),

    ]
    , form: [
        ...controls.displayText({
            tab: "filter", label: "Employee",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "employee_code", controlType: "Employee", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
        ...controls.displayText({
            tab: "filter", label: "Branch",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "branch_code", controlType: "Branch", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
        ...controls.displayText({
            tab: "filter", label: "Designation",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "designation_code", controlType: "Designation", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
        ...controls.displayText({
            tab: "filter", label: "Department",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "department_code", controlType: "Department", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),


        ...controls.displayText({
            tab: "filter", label: "EmploymentStatus",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "employment_status_code", controlType: "EmploymentStatus", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

        ...controls.displayText({
            tab: "filter", label: "EmploymentGrade",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "employment_grade_code", controlType: "EmploymentGrade", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),




        ...controls.magicDateLabel({ tab: "general", label: "Month", target: "month", star: true }),
        ...controls.magicDate({ tab: "general", name: "month", dateType: "monthYear", isRequired: true, isReadOnly: "edit", displayFormat: "MMMM yyyy" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Da In Percentage", star: true }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "da_in_percentage", isRequired: true, maxlength: 4, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Hra In Percentage", star: true }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "hra_in_percentage", isRequired: true, maxlength: 4, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "" }),
    ]
    , history: {
        perPage: 10,
        reportHeader: "Generate Salarys",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        clickable: true,
        displayColumns: [
            { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
            { Header: "Name as on ID", accessor: "GenerateSalary-employee-employee_display", },
            { Header: "Branch", accessor: "GenerateSalary-branch-branch_display", },
            { Header: "Designation", accessor: "GenerateSalary-designation-designation_display", },
            { Header: "Department", accessor: "GenerateSalary-department-department_display", },
            { Header: "Month", accessor: "month", type: 'date' },
        ]
    }
};
export default generate_salarys;